import React, { useRef, useEffect, useState } from 'react';
import cn from 'classnames';

function AccordionItem({ children, title, icon, onClick, isOpen, theme, ignoreHeight }) {
  const contentHeight = useRef();
  const [maxHeight, setMaxHeight] = useState(0);

  const titleSlug = title ? String(title).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') : 'accordion';
  const contentId = `accordion-content-${titleSlug}`;

  function handleChildClick(e) {
    e.stopPropagation();
  }

  useEffect(() => {
    if (ignoreHeight || !contentHeight.current) return;

    if (isOpen) {
      if (contentHeight.current) {
        setMaxHeight(contentHeight.current.scrollHeight);
      }
    }
  }, [isOpen, ignoreHeight, children]);

  function getStyle() {
    if (ignoreHeight) return {};

    return isOpen
      ? { maxHeight: maxHeight + 'px', overflow: 'hidden' }
      : { maxHeight: '0px', overflow: 'hidden' };
  }

  return (
    <div
      className={cn(theme.AccordionItem, { [theme.AccordionItem__open]: isOpen })}
    >
      <div
        className={cn(theme.AccordionItem_header, { [theme.AccordionItem_header__open]: isOpen })}
        role='button'
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(e); } }}
        aria-expanded={isOpen}
        aria-controls={contentId}
      >
        <span
          className={cn('icon', {
            'icon-arrow-down': !isOpen,
            'icon-arrow-up': isOpen,
          })}
        />
        <h3 className={cn(theme.AccordionItem_title, 'u-mb0')}>{icon} {title}</h3>
      </div>
      <div
        id={contentId}
        className={cn(theme.AccordionItem_content, { [theme.AccordionItem_content__open]: isOpen })}
        ref={contentHeight}
        style={getStyle()}
        role='region'
      >
        <div className={theme.AccordionItem_content__wrapper} onClick={(e) => handleChildClick(e)}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default AccordionItem;
